export const formatTimestamp = (isoString) => {
    if (!isoString) return null;
    if (isoString instanceof Date) isoString = isoString.toISOString();
    const normalized = (isoString.endsWith('Z') || /[+-]\d{2}:?\d{2}$/.test(isoString))
        ? isoString
        : isoString + 'Z';
    const d = new Date(normalized);
    return d.toLocaleString('ru-RU', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Europe/Moscow',
    });
};
